var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 28,
    viewBox: "0 0 18 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_10",
    "data-name": "Polygon 10",
    d: "M12.421,2.03a2,2,0,0,1,3.157,0l9.911,12.742A2,2,0,0,1,23.911,18H4.089a2,2,0,0,1-1.579-3.228Z",
    transform: "translate(18) rotate(90)",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDE4IDI4Ij4KICAgIDxwYXRoIGlkPSJQb2x5Z29uXzEwIiBkYXRhLW5hbWU9IlBvbHlnb24gMTAiIGQ9Ik0xMi40MjEsMi4wM2EyLDIsMCwwLDEsMy4xNTcsMGw5LjkxMSwxMi43NDJBMiwyLDAsMCwxLDIzLjkxMSwxOEg0LjA4OWEyLDIsMCwwLDEtMS41NzktMy4yMjhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOCkgcm90YXRlKDkwKSIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4=";
export { SvgTriangleRight as ReactComponent };